import { render, staticRenderFns } from "./election2026.vue?vue&type=template&id=12cc023e&"
import script from "./election2026.vue?vue&type=script&lang=js&"
export * from "./election2026.vue?vue&type=script&lang=js&"
import style0 from "./election2026.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports